export const editName = "questionAnswer" as const;
export const renderName = "QuestionAnswer" as const;
